'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /** Separator text */
  text: _propTypes2.default.node.isRequired,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the text element */
  textStyle: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};

var defaultProps = {
  style: {},
  textStyle: {}
};

var displayName = 'MessageSeparator';

/** A separator to show above a Message */
var MessageSeparator = function MessageSeparator(_ref) {
  var text = _ref.text,
      style = _ref.style,
      textStyle = _ref.textStyle;
  return _react2.default.createElement(
    'section',
    { style: _getStyles2.default.root(style) },
    _react2.default.createElement(
      'p',
      { style: _getStyles2.default.text(textStyle) },
      text
    )
  );
};

MessageSeparator.propTypes = propTypes;
MessageSeparator.defaultProps = defaultProps;
MessageSeparator.displayName = displayName;

exports.default = MessageSeparator;
module.exports = exports.default;